import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractCrudService } from '../crud/abstract-crud.service';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';

@Injectable()
export class PeopleMultiSelectService extends AbstractCrudService {
    override title: string = 'Pessoas';
    override pluralTitle = 'Pessoas';

    constructor(protected override httpClient: HttpClient) {
        super(httpClient, 'people');
    }

    public findByFilter(filterForm: any, pagination: any): Observable<any[]> {
        let params = {
            ...{ getRelation: 0, limit: 36, page: 0, filter: '' },
            ...pagination,
        };

        return this.httpClient.post<any[]>(
            `${API_PATH}${this.relativeUrl}/filter`,
            { ...filterForm, ...params }
        );
    }

    public getCustomers(): Observable<any[]> {
        return this.httpClient.get<any[]>(`${API_PATH}${this.relativeUrl}/customers`);
    }

    public getPartners(): Observable<any[]> {
        return this.httpClient.get<any[]>(`${API_PATH}${this.relativeUrl}/partners`);
    }

    public getContacts(): Observable<any[]> {
        return this.httpClient.get<any[]>(`${API_PATH}${this.relativeUrl}/contacts`);
    }
} 